import React from 'react';
import Input from '../../Input';
export default function Text(props) {
    return <Input {...props}></Input>;
}
